export default () => {

  // Selectors

  const formSubmitToggle = document.querySelector('.form-submit');
  const giftCardVariantId = document.getElementById('gift-card-variant-id');
  const inputs = document.querySelectorAll('.required');
  const propertiesInput = document.getElementById('gift-card-properties');
  const lineItemProps = {};
  const button = document.querySelector('.gc-addtocart-btn');
  const address = document.getElementById('autocomplete');
  let autocomplete;
  let addressOrigValue = '';
  let isSelected = false;
  const options = {
    componentRestrictions: { country: 'au' },
    types: ['address'],
  };

  // Form Validation

  const isEmailValid = (email) => {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  const hasLimit = (input, error, onSubmitActive = false) => {
    const inputHasLimit = input.getAttribute('maxlength');
    if (inputHasLimit) {
      const limit = Number(inputHasLimit);
      if (error.getAttribute('data-limit-error') !== error.innerHTML) {
        error.setAttribute('data-default-error', error.innerHTML);
      }
      if (input.value.length === limit) {
        showError(input, error);
        error.innerHTML = error.getAttribute('data-limit-error');
      } else {
        hideError(input, error);
        error.innerHTML = error.getAttribute('data-default-error');
        if (!onSubmitActive) return;
        if (input.value === '') {
          showError(input, error);
        } else {
          hideError(input, error);
        }
      }
    }
  };

  const showError = (element, error) => {
    if (element !== null) {
      element.classList.add('form-field__input--error');
    }
    error.style.display = 'block';
  };

  const hideError = (element, error) => {
    if (element !== null) {
      element.classList.remove('form-field__input--error');
    }
    error.style.display = 'none';
  };

  const formButtons = (valid) => {
    if (valid) {
      if (button === null && formSubmitToggle === null) return;
      button.style.display = 'block';
      formSubmitToggle.style.display = 'none';
    } else {
      button.style.display = 'none';
      formSubmitToggle.style.display = 'inline-flex';
    }
  };

  const validateFormInput = () => {
    let isValid = false;
    let isChecked = false;
    const onSubmitActive = true;
    const validInputs = Array.from(inputs).filter(
      (input) => input.value === '' && input.type !== 'radio',
    );
    const validRadios = Array.from(inputs).filter(
      (input) => input.checked && input.type === 'radio',
    );

    if (validInputs.length === 0) isValid = true;
    if (validRadios.length > 0) isChecked = true;

    inputs.forEach((input) => {
      const parent = input.closest('.form-field');
      const error = parent.querySelector('.form-field__error');
      const radios = parent.querySelectorAll('input[type="radio"]');
      
      if (error === null) return;

      if (input.type === 'email' && !isEmailValid(input.value.trim())) isValid = false;
      if (input.type === 'radio' && input.checked) isChecked = true;
      if (address) {
        if (autocomplete.getPlace() === undefined && address) isValid = false;
      }

      if (input.type === 'radio') {
        showError(null, error);
        if (isChecked) hideError(null, error);
        radios.forEach((radio) => {
          radio.addEventListener('change', () => {
            if (radio.checked) {
              hideError(null, error);
            }
          });
        });
        return;
      }

      if (input.value === '') {
        showError(input, error);
      }
      if (input.type === 'email') {
        const email = input.value.trim();
        if (input.value === '' || !isEmailValid(email)) {
          showError(input, error);
        }
      }
      input.addEventListener('input', () => {
        if (input.value === '') {
          showError(input, error);
        } else {
          hideError(input, error);
        }

        hasLimit(input, error, onSubmitActive);

        if (input.id === 'autocomplete' && !isValid) showError(input, error);
      });
    });

    return {
      isValid,
      isChecked,
      validInputs,
    };
  };

  const validateFormButton = () => {
    let isValid = false;
    let isChecked = false;
    let place;
    const validNewInputs = [];
    const validNewChecks = [];
    inputs.forEach((input) => {
      let isFocused = true;
      const parent = input.closest('.form-field');
      const error = parent.querySelector('.form-field__error');
      if (input.type !== 'radio') {
        validNewInputs.push(true);
      }

      if (input.type === 'radio') {
        validNewChecks.push(true);
      }
      if (address) {
        address.addEventListener('blur', () => {
          isSelected = true;
        });
      }

      input.addEventListener('input', () => {
        if (input.type === 'email' && input.value !== '' && !isEmailValid(input.value.trim())) return;
        if (input.value !== '' && isFocused && input.type !== 'radio') {
          validNewInputs.pop(true);
          isFocused = false;
        }
        if (input.value === '' && !isFocused && input.type !== 'radio') {
          validNewInputs.push(true);
          isFocused = true;
        }

        if (input.type === 'radio') isChecked = true;
        if (validNewInputs.length === 0) isValid = true;
        if (validNewInputs.length > 0) isValid = false;

        if (validNewChecks.length === 0) formButtons(isValid);
        if (validNewChecks.length > 0) formButtons(isValid && isChecked);

        hasLimit(input, error);
        if (!address) return;
        const addressError = address.closest('.form-field').querySelector('.form-field__error');
        if (input.id === 'autocomplete') {
          if (place === undefined) {
            showError(address, addressError);
          }
          if (place === undefined && validNewInputs.length === 0) {
            showError(address, addressError);
          }
        }
        if (place === undefined && validNewInputs.length === 0) {
          formButtons(false);
        }
        if (validNewInputs.length === 0 && addressOrigValue === address.value) {
          hideError(address, addressError);
          formButtons(true);
        }
      });
    });
  };

  // Gift Card Form

  const giftCardInit = () => {
    // console.log('init');
    initLineItemProps();
    if (giftCardVariantId === null) return;
    giftCardVariantId.disabled = false;
    getVariantData();
  };

  const initLineItemProps = () => {
    if (!propertiesInput) return;
    document.querySelectorAll('[name^="properties"]').forEach((el) => {
      
      el.addEventListener('change', ({ target }) => {
        const inputName = target ? target.name : '';
        const lineItemKey = inputName ? inputName.replace('properties[', '').replace(']', '') : '';
        const lineItemKey2 = lineItemKey.replace('__', '').replace('giftcard_', '');
        const shadowLineItemKey = lineItemKey2.charAt(0).toUpperCase() + lineItemKey2.slice(1);
        lineItemProps[lineItemKey] = target.id === 'autocomplete' ? address.value : target.value;
        lineItemProps[shadowLineItemKey] = target.value;
        if (lineItemKey === '__giftcard_email') {
          lineItemProps['__giftcard_medium'] = 'email';
        }
        propertiesInput.value = JSON.stringify(lineItemProps);
      });
    });
  };

  const getVariantData = () => {
    const radios = document.querySelectorAll('.form-field--radio input[type="radio"]');
    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        giftCardVariantId.value = radio.dataset.variantId;
      });
    });
  };

  const onFormSubmit = (event) => {
    event.preventDefault();
    const { isValid, isChecked } = validateFormInput();
    inputs.forEach((input) => {
      const accordion = input.closest('[data-accordion]');
      if (!accordion) return;
      if (input.type === 'radio') {
        if (!isChecked) {
          accordion.open();
        } else {
          accordion.close();
        }
        return;
      }
      if (input.type !== 'radio') {
        if (!isValid) {
          accordion.open();
        } else {
          accordion.close();
        }
      }
    });
  };

  const showSpinner = (element) => {
    if (element.querySelector('.loading-spinner') === null) return;
    element.classList.add('loading');
    element.querySelector('.loading-spinner').classList.remove('hidden');
  };

  const hideSpinner = (element) => {
    if (element.querySelector('.loading-spinner') === null) return;
    element.classList.remove('loading');
    element.querySelector('.loading-spinner').classList.add('hidden');
  };

  const resetInput = () => {
    const resetInputs = document.querySelectorAll('[form="form-data"]');
    const textWrap = document.querySelectorAll('[data-replicated-value]');
    const select = document.querySelectorAll('.form-field__select');
    if (!resetInputs) return;
    validateFormButton();
    formButtons(false);
    textWrap.forEach((textarea) => {
      textarea.dataset.replicatedValue = '';
    });
    if (select !== null) {
      select.forEach((select) => {
        select.setAttribute('value', '');
      });
    }
    resetInputs.forEach((input) => {
      const parent = input.closest('.form-anim--focused');
      const error = input.closest('.form-field').querySelector('.form-field__error');
      input.value = '';
      if (input.type === 'radio' || input.type === 'radio') {
        input.checked = false;
      }
      if (parent) parent.classList.remove('form-anim--focused');

      hideError(input, error);
    });
  };

  // Physical Gift Card

  function autocompleteInit() {
    autocomplete = new google.maps.places.Autocomplete(address, options);
    autocomplete.addListener('place_changed', onPlaceChanged);
  }

  function onPlaceChanged() {
    const addressError = address.closest('.form-field').querySelector('.form-field__error');
    const place = autocomplete.getPlace();
    const newInputs = [];
    inputs.forEach((input) => {
      newInputs.push(true);
      if (input.value !== '') {
        newInputs.pop(true);
      }
    });
    if (newInputs.length === 0 && isSelected) formButtons(true);
    if (place.geometry) {
      hideError(address, addressError);
      autocompleteInit();
      const lineItemKey = address.name ? address.name.replace('properties[', '').replace(']', '') : '';
      lineItemProps[lineItemKey] = address.value;
      addressOrigValue = address.value;
      propertiesInput.value = JSON.stringify(lineItemProps);
    }
  }

  // Gift Card Balance

  const balanceButton = document.querySelector('.gift-card__balance-button');
  const amountContent = document.querySelector('.gift-card__balance-amount');
  const giftCardInput = document.getElementById('giftCardCode');
  const giftCardError = document.querySelector('.gift-card__balance-error');

  const getBalanceData = () => {
    fetch(
      `https://australia-southeast1-giftnote-app.cloudfunctions.net/prod/vouchers/balance?code=${giftCardInput.value.trim()}`,
      {
        method: 'GET',
        headers: {
          shop: Shopify.shop
        }
      }
    )
      .then((response) => response.json())
      .then((json) => {
        const { data } = json;
        if (data.status === 'Not Found') {
          showError(giftCardInput, giftCardError);
          return;
        }
        hideError(giftCardInput, giftCardError);
        amountContent.textContent = data.balance;
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        hideSpinner(balanceButton);
      });
  };

  const checkBalanceSubmit = (event) => {
    event.preventDefault();
    const { isValid } = validateFormInput();
    if (isValid) {
      showSpinner(balanceButton);
      getBalanceData();
    }
  };

  if (balanceButton !== null) {
    balanceButton.addEventListener('click', checkBalanceSubmit);
  }

  if (formSubmitToggle !== null) {
    formSubmitToggle.addEventListener('click', onFormSubmit);
  }

  if (button !== null) {
    button.addEventListener('click', resetInput);
  }

  window.addEventListener('pagehide', resetInput);

  document.addEventListener('DOMContentLoaded', () => {
    giftCardInit();
    if (address) autocompleteInit();
    if (inputs) validateFormButton();
  });
};
